export default __webpack_public_path__ + "static/productHoverImage-cb8eaaccc9bcd5394f6075048c95c3d4.jpg";